module.exports = __webpack_public_path__ + "static/media/sopt23ru.ca311c76.pdf";